import React from 'react'
import Login from './Login'

const Signin = () => {
  return (
    <div className="min-h-dvh bg-wa-app text-wa-text">
      <Login />
    </div>
  );
}

export default Signin
